import React from "react";
import { useEffect, useState } from "react";
import { ConnectButton, useWalletKit } from "@mysten/wallet-kit";
import { useStakings } from "../../context";
import { useGetBalance } from "../../hooks";
import { OBJECT_RECORD } from "../../config";

import { SuiLogo } from "../sui";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Socials } from "../socials";

export const Header = (props) => {
  const { currentAccount } = useWalletKit();
  const [address, setAddress] = useState("");

  const { state } = useStakings();
  useEffect(() => {
    if (currentAccount?.address) {
      let tempAddr = currentAccount?.address;
      setAddress(tempAddr.slice(0, 4) + "..." + tempAddr.slice(-4));
    }
  }, [currentAccount]);

  useGetBalance(currentAccount?.address || OBJECT_RECORD.ADDRESSZERO, 0);
  return (
    <div className="w-full fixed top-0 left-0 px-[1vw] flex z-10 py-8 justify-center">

      <div className="w-full flex items-center justify-between rounded-[2rem] bg-[#fef2b9] min-h-60 md:min-h-70 lg:h-80 px-16 box-shadow-paw max-w-[96rem]">
        <div className="w-60 md:w-70 lg:w-80">
          <img src="/logo192.png" alt="logo" />
        </div>
        <div className="flex gap-20">
          <div className="socials-link flex gap-10 items-center">
            <Socials />
          </div>
          <div className="flex justify-between items-center gap-10 rounded-[2rem] box-shadow-paw btn-connect">
            {!!currentAccount && (
              <div className="flex justify-between items-center gap-10 pl-10 rounded-md">
                <span className="text-12 md:text-15 font-semibold cursor-pointer">
                  {state["balance"]}
                </span>
                <SuiLogo />
              </div>
            )}

            <ConnectButton
              connectedText={address}
              connectText={"Connect Wallet"}
              className="px-12 md:px-15 py-5 md:py-12 text-12 md:text-15 rounded-md cursor-pointer btn-connect"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
